import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

type CSSPosition = 'static' | 'relative' | 'absolute' | 'fixed' | 'sticky';
interface MailtoPayload {
  to: string;
  subject: string;
  body: string;
}

@Component({
  selector: 'feedback-card',
  templateUrl: './feedback-card.component.html',
  styleUrls: ['./feedback-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeedbackCardComponent {
  @Input() containerDisplay = 'flex';
  @Input() containerDirection: 'row' | 'column' = 'column';
  @Input() containerPadding = '16px 50px';
  @Input() iconContainerPosition: CSSPosition = 'static';
  @Input() iconPosition: CSSPosition = 'static';
  @Input() iconTop = 'auto';
  @Input() iconRight = 'auto';
  @Input() footerTop = '60px';
  @Input() iconContainerMarginTop = '20px';
  @Input() containerBorderColor = '#e5e5e5';

  @Input() feedbackBody =
    'Thank you for being an early user of Clinical Decision Suite. Your input goes straight to our product team to guide future improvements.';

  @Input() mailtoTo = 'cds-support@thermofisher.com';
  @Input() mailtoSubject = 'CDS Feedback';
  @Input() mailtoBody =
    'Hello Clinical Decision Suite product team,\n\n' +
    "I'd like to share the following feedback:\n\n" +
    '[Please type your comments here]\n\n' +
    'Thank you,\n[Your Name]';

  @Output() openRequested = new EventEmitter<MailtoPayload>();

  onOpenRequested(): void {
    this.openRequested.emit({
      to: this.mailtoTo,
      subject: this.mailtoSubject,
      body: this.mailtoBody
    });
  }
}
